/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsDeleteContent: {
  name: 'delete-content';
  data: string;
} = {
  name: 'delete-content',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.354 2.94a1.5 1.5 0 0 1 1.06-.44H14A1.5 1.5 0 0 1 15.5 4v8a1.5 1.5 0 0 1-1.5 1.5H6.414a1.5 1.5 0 0 1-1.06-.44l-4-4a1.5 1.5 0 0 1 0-2.12l4-4Zm1.06.56a.5.5 0 0 0-.353.146l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .353.146H14a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5H6.414Zm5.94 2.146a.5.5 0 0 1 0 .708L10.707 8l1.647 1.646a.5.5 0 1 1-.707.708L10 8.707l-1.646 1.647a.5.5 0 0 1-.707-.708L9.293 8 7.647 6.354a.5.5 0 1 1 .707-.708L10 7.293l1.646-1.647a.5.5 0 0 1 .708 0Z" fill="currentColor"/></svg>`,
};
